export class UploadDocument {
    Tenant: number;
    Extension: string;
    UploadMode: string;
    ShipmentNumber: string;
    BlocksNumber: number;
    FileSize: number;
    BufferNumber: number;
    SentSize: number;
    Base64String: string;
    FileName: string;
    DocumentTypeId: string;
    BlockIdsList: string[];
    IsFirstTry: boolean;
    EntityId:string;
}